export type SectionType =
  | 'INTRO' | 'VERSE' | 'PRE_CHORUS' | 'CHORUS'
  | 'BRIDGE' | 'OUTRO' | 'INSTRUMENTAL' | 'INTERLUDE' | 'TAG';

export const MUSICAL_KEYS = [
  'C', 'C#', 'Db', 'D', 'D#', 'Eb', 'E',
  'F', 'F#', 'Gb', 'G', 'G#', 'Ab', 'A', 'A#', 'Bb', 'B',
] as const;

export type MusicalKey = typeof MUSICAL_KEYS[number];
export type SongMode = 'MAJOR' | 'MINOR';

export interface Section {
  id: string;
  type: SectionType;
  title: string;
  content: string;
  order: number;
}

export interface SongVersion {
  id: string;
  version_number: number;
  sections: Section[];
  created_at: string;
}

export interface Song {
  id: string;
  ministry_id: string | null;
  title: string;
  artist: string;
  key: string;
  mode: SongMode;
  bpm: number | null;
  created_by_id: string | null;
  created_by_name: string;
  is_public: boolean;
  source_song_id: string | null;
  shared_ministry_ids: string[];
  usage_count: number;
  latest_version: SongVersion | null;
  created_at: string;
  updated_at: string;
}

export interface SongListItem {
  id: string;
  title: string;
  artist: string;
  key: string;
  mode: SongMode;
  bpm: number | null;
  created_by_id: string | null;
  created_by_name: string;
  is_public: boolean;
  source_song_id: string | null;
  shared_ministry_ids: string[];
  usage_count: number;
  updated_at: string;
}

export interface PublicSongListItem {
  id: string;
  title: string;
  artist: string;
  created_by_name: string;
  usage_count: number;
  is_saved: boolean;
}

export interface Team {
  id: string;
  name: string;
  ministry_id: string;
  invite_code: string;
  created_at: string;
}

export interface CreateSongPayload {
  title: string;
  artist?: string;
  key?: string;
  mode?: SongMode;
  bpm?: number | null;
  is_public?: boolean;
  sections?: { type: SectionType; title: string; content: string }[];
}

export type UpdateSongPayload = Partial<CreateSongPayload>;
